import * as React from 'react'
import styled from '@emotion/styled'

import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'

import {Text} from '../Text'
import {LOGO_HEIGHT} from './constants'

export const StyledProviderText = styled(Text)`
  height: ${LOGO_HEIGHT}px;
  color: #06b679;
  display: flex;
  align-items: center;
  text-transform: capitalize;
`

export const BookWithHotel = () => {
  return (
    <StyledProviderText variant="titleS">
      <FormattedMessageWrapper
        id="bookWithHotel"
        defaultMessage="Book with hotel"
      />
    </StyledProviderText>
  )
}
